import 'jquery';
global.jQuery = $;
import 'jquery-validation';

const MobileDetect = require("mobile-detect");
import { initForms } from './modules/forms';
import { initNavigation } from './modules/navigation';
import { initFontAwesome } from './modules/fontAwesome';
import { initSwiper } from './modules/swiper';
import { Equalizer, Reveal } from "foundation-sites";
import { initParallax } from './modules/parallax';
// import { initSlideIn } from './modules/slideIn';
import { initSticky } from './modules/sticky';
// import { initSVGText } from './modules/svgText.js';
import{ initBigText } from './modules/bigText.js';
import{ initSmoke } from './modules/smoke.js';
import{ initVideo } from './modules/video.js'
import{ initGallery } from './modules/gallery.js'
import{ initVideoPopup } from './modules/video-popup.js'

(($) => {
  'use strict';

  // If Foundation modules are installed uncomment this line
  $(document).foundation();
  var md = new MobileDetect(window.navigator.userAgent);

  $(document).ready(() => {
    initBigText(md);
    initForms();
    initNavigation(md);
    initFontAwesome();
    initSwiper(md);
    initParallax('.image-slider--large .swiper-slide__image', '.image-slider .swiper-slide',md);
    initParallax('.teaser-slice__image', '.teaser-slice',md);
    initParallax('.buttons-slice-button__image', '.teaser-slice',md);
    // initSlideIn();
    initSticky(md);
    initSmoke(md);
    initBigText(md);
    initVideo();
    initGallery();
    updateSliderHeight();
    initVideoPopup();

    window.resizeTimeout = setTimeout(fixLayout,250);
    $(window).on('resize',function(e){
      if( window.resizeTimeout ) {
        clearTimeout(window.resizeTimeout);
      }
      window.resizeTimeout = setTimeout(fixLayout,500);
    });


    $('.buttons-slice-button').on('click',function(i,e){
      $(e).addClass('hover');
    });

  });

  /**
   * Correct layout after resize
   */
  function fixLayout() {
    initBigText(md);
    $(".image-slider__title").css("opacity",1);
    $(".image-slider__sub-title").css("opacity",1);
    updateSliderHeight();
    updateStaticTitles();
    equalizeHeights();
  }

  function equalizeHeights(){
    $('.equalize').each(function(index,el){

      var h = 0;
      $(el).find('.equalize-watch').each(function(j,el2){
        var item = $(el2);
        item.css('height','auto');
        var item_h = item.height();
        if( h < item_h ){
          h = item_h;
        }
      });

      $(el).find('.equalize-watch').height(h);
    });
  }

  function updateSliderHeight(){
    if (md.phone() ) {
      var h = $(window).height() - 20;
      $(".image-slider--large").first().height(h);
    }
    if (md.tablet() ) {
      var h = $(window).height() - 30;
      $(".image-slider--large").first().height(h);
    }
  }

  function updateStaticTitles(){
    var title = $('.image-slider__title')[0];
    var y = parseInt($(title).css('top')) + $(title).outerHeight() + 0;
    $('.image-slider__sub-title').css('top',y);
  }


})(jQuery);
